import React from "react";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import { Button } from "@mui/material";

const DietHeaderInfo = ({ formData, setIsClientDetails }) => {
  if (!formData) return null;

  const clientName = formData?.clientName?.name || "Unknown Client";
  const weekPlan = formData?.weekPlan?.label || "Week plan not set";
  const chartType = formData?.chartType?.label || "Chart type not set";
  const dateRange =
    formData?.from && formData?.to
      ? `${formData.from} - ${formData.to}`
      : "Dates not set";

  return (
    <SuiBox
      sx={{
        display: "flex",
        alignItems: "center",
        py: 0.5,
        gap: 2,
      }}
    >
      {/* Left Side: Details */}
      <SuiBox textAlign="left">
        <SuiTypography
          variant="subtitle2"
          fontWeight="bold"
          sx={{
            fontSize: "0.95rem",
            color: formData?.clientName?.name ? "inherit" : "text.disabled",
          }}
        >
          {clientName}
        </SuiTypography>

        <SuiTypography
          variant="caption"
          color="text.secondary"
          sx={{ fontSize: "0.8rem" }}
        >
          {weekPlan}

          {" • "}

          <span
            style={{
              fontWeight: 500,
              color: formData?.chartType?.label ? "#555" : "#aaa",
            }}
          >
            {chartType}
          </span>

          {" • "}

          <span
            style={{ color: formData?.from && formData?.to ? "#888" : "#aaa" }}
          >
            {dateRange}
          </span>
        </SuiTypography>
      </SuiBox>

      <SuiButton
        component={Button}
        color="dark"
        disabled={!formData?.clientName?.key}
        variant="gradient"
        onClick={() => setIsClientDetails(true)}
        sx={{
          px: 2,
          textTransform: "none",
          fontWeight: 500,
          borderRadius: "6px",
        }}
      >
        Client Details
      </SuiButton>
    </SuiBox>
  );
};

export default DietHeaderInfo;
